import type { ILocationNote } from './../types/note/models'
import { makeNoteService } from '~/cynqueModules/factoriesForServices/notes'

export const {
  createNote: createLocationNote,
  updateNote: updateLocationNote,
  deleteNote: deleteLocationNote,
} = makeNoteService<ILocationNote>('/api/locationnotes', 'locationNote')
